import { formatNumberToString } from "../../utils";
// Finds values that are in the first array that are not in the second array.
export const differenceInArrayValues = (a1, a2) => {
    if (a1 === undefined || a2 === undefined) {
        return [];
    }
    return a1.filter(o1 => a2.filter(o2 => o2 === o1).length === 0);
};
export const formatContent = (content, formatter, fractionDigits) => {
    const digitsToRound = fractionDigits ? fractionDigits : 0;
    switch (formatter) {
        case 'formatNumberToString':
            return formatNumberToString(content, digitsToRound);
        default:
            return content;
    }
};
//# sourceMappingURL=helpers.js.map